import saga from "./saga";
import slice from "./slices";

const auth = {
  slice,
  saga,
};

export default auth;
